import CourseNavigationProvider from 'bundles/course-v2/providers/CourseNavigationProvider/CourseNavigationProvider';

export { useCourseNavigationContext } from 'bundles/course-v2/providers/CourseNavigationProvider/CourseNavigationProvider';
export default CourseNavigationProvider;
